import Accordion from '@/common/components/Accordion'
import InfoField from '@/common/components/InfoField'
import { EquipmentModelLatestFipeDataAutonomy } from '@/features/equipmentModels/types/equipmentModelLatestFipe'

interface FipeAutonomyAccordionProps {
  autonomyData?: EquipmentModelLatestFipeDataAutonomy
}

export default function FipeAutonomyAccordion({ autonomyData }: FipeAutonomyAccordionProps) {
  return (
    <Accordion
      name="Autonomy"
      head="Autonomia"
      body={
        <div className='flex items-center gap-1'>
          <InfoField 
            label="Urbana" 
            value={autonomyData?.Urbana} 
          />
          <InfoField 
            label="Rodoviária" 
            value={autonomyData?.Rodoviaria} 
          />
        </div>
      }
    />
  )
}